// Designer wrapper around the shared project-wide audit-log modal
// (@twasta/page-runtime/txn/list). The shared modal takes an injected
// `fetchAuditLog` (the package carries no HTTP client); this wrapper
// pre-binds the platform's livepreview fetcher so existing call sites are
// unchanged.

import { PreviewAuditModal as CorePreviewAuditModal } from '@twasta/page-runtime/txn/list'
import { livePreviewAuditLog } from '../api'

interface Props {
  project: string
  /** Pre-fill the object filter (the currently-open transaction). */
  defaultObjName?: string
  onClose: () => void
}

export default function PreviewAuditModal(props: Props) {
  return <CorePreviewAuditModal {...props} fetchAuditLog={livePreviewAuditLog} />
}
